var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "projectFileUpload",
      class: _vm.dropActive ? "drag-active" : "",
      staticStyle: { "min-height": "650px", padding: "10px" },
      on: {
        drop: function ($event) {
          $event.preventDefault()
          return _vm.drop.apply(null, arguments)
        },
        dragenter: function ($event) {
          $event.preventDefault()
          return _vm.dragenter.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.dragover.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.dragleave.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "margin-bottom": "10px",
            "max-height": "300px",
            "z-index": "5",
          },
        },
        [
          _vm.fileList.length > 0
            ? _c("el-image", {
                staticStyle: {
                  "object-fit": "contain",
                  height: "300px",
                  width: "540px",
                },
                attrs: { src: _vm.getFullPathUrl(_vm.currentFile), alt: "" },
                on: {
                  click: function ($event) {
                    return _vm.showPic()
                  },
                  error: function ($event) {
                    return _vm.hideErrorImage()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              attrs: {
                "list-type": "picture-card",
                accept: ".jpg, .jpeg, .png, .JPG, .JPEG, .PNG, .MP4, .mp4",
                action: "#",
                multiple: _vm.multiple,
                "file-list": _vm.fileList,
                "show-file-list": true,
                "on-remove": _vm.onRemove,
                "on-progress": _vm.onProgress,
                "before-remove": _vm.beforeRemove,
                "before-upload": _vm.beforeUpload,
                "http-request": _vm.uploadImage,
                "auto-upload": true,
              },
            },
            [
              _vm._t("default", function () {
                return [_c("i", { staticClass: "el-icon-plus" })]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          staticClass: "images",
        },
        _vm._l(_vm.getAllImg(), function (src, index) {
          return _c("img", { key: index, attrs: { src: src } })
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }